export enum MessageType {
	standard = 1,
	system = 2,
	reminder = 3,
}
